var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import MuiStepLabel from '@mui/material/StepLabel';
import { StatusIcon } from '../../status';
import { CheckIcon } from '../../icon';
var CustomStepIcon = function (_a) {
    var active = _a.active, completed = _a.completed;
    return (React.createElement(StatusIcon, { icon: CheckIcon, variant: active || completed ? 'filled' : 'default', color: completed ? 'success' : 'default' }));
};
export var StepLabel = React.forwardRef(function (props, ref) {
    return React.createElement(MuiStepLabel, __assign({ StepIconComponent: CustomStepIcon }, props, { ref: ref }));
});
